import React, { FC } from 'react'

import noResults from '../assets/img/no-results.png'
import { Button } from '../layout_components/Button'
import { locale } from '../locales/locale'
import { ElementNotFoundContainer } from './customComponents'
interface Props {
    onClick: (searchKey: string, page: string) => void
    type: string
}

const ElementNotFound: FC<Props> = ({ onClick, type }: Props) => {
    return (
        <ElementNotFoundContainer>
            <img srcSet={noResults + ' 3x'} alt={'No results found'} />
            <div style={{ margin: '20px 0' }}>
                {type === 'section'
                    ? locale('La sezione cercata non esiste.')
                    : locale("L'articolo cercato non esiste.")}
            </div>
            <Button
                size={'medium'}
                text={locale('Torna alla home')}
                onClick={() => onClick(undefined, 'main')}
            />
        </ElementNotFoundContainer>
    )
}

export default ElementNotFound